import {
  UPLOAD_FILE_REQUEST,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  SET_SELECTED_FILE,
  RESET_UPLOAD_FILE_STATE,
} from "./UploadCsvTypes";

const initialState = {
  loading: false,
  file: null,
  error: null,
  success: null,
  data: null,
  errorFields: null,
};

const uploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_FILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
        data: null,
      };

    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        success: action.payload,
        error: null,
      };

    case UPLOAD_FILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: null,
        errorFields: action.payload.errorFields,
        data: null,
      };

    case SET_SELECTED_FILE:
      return {
        ...state,
        file: action.payload,
        error: null,
        data: null,
        success: null,
      };
    case RESET_UPLOAD_FILE_STATE:
      return {
        ...state,
        loading: false,
        file: null,
        error: null,
        success: null,
        data: null,
        errorFields: null,
      };
    default:
      return state;
  }
};

export default uploadReducer;
